import { useTrackBreadcrumbs } from 'BreadcrumbNavigation';
import { isLearningSectionPath } from './learningPathMatchers';

export function useTrackLearningSectionBreadcrumbs() {
    // Track breadcrumbs for dashboard routes (student dashboard and stream dashboard)
    return useTrackBreadcrumbs({
        section: 'learning',
        pathMatcher: isLearningSectionPath,
    });
}
